import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useEditorDrag } from "../../../canvas/dnd/useEditorDrag";
import { usePaletteItemActivate } from "../../../canvas/dnd/usePaletteItemActivate";
import { BLOCK_DEFINITION_PALETTE } from "../../../domain/blocks/registry";
import type { BlockType } from "../../../domain/types";
import { insertBlockFromPalette } from "./blockPaletteInsert";
import { BlockPaletteGlyph } from "./paletteGlyphs";
import "components/builderShell/builderToolbarMenuView.scss";
import "./emailBuilderAddElementsPanel.scss";

interface IEmailBuilderBlockPaletteProps {
  onAfterInsert?: () => void;
}

export function EmailBuilderBlockPalette(props: IEmailBuilderBlockPaletteProps) {
  const { onAfterInsert } = props;
  const { t } = useTranslation();

  return (
    <div className="builder-toolbar-palette-grid">
      {BLOCK_DEFINITION_PALETTE.map(item => (
        <BlockPaletteItem
          key={item.type}
          blockType={item.type}
          label={t(item.label)}
          onInsert={() => {
            insertBlockFromPalette(item.type);
            onAfterInsert?.();
          }}
        />
      ))}
    </div>
  );
}

function BlockPaletteItem({
  blockType,
  label,
  onInsert,
}: {
  blockType: BlockType;
  label: string;
  onInsert: () => void;
}) {
  const { dragRef, isDragging } = useEditorDrag(
    { kind: "palette-block", blockType },
    { id: `palette-block:${blockType}` },
  );
  const handleActivate = usePaletteItemActivate(onInsert, isDragging);

  return (
    <button
      type="button"
      ref={dragRef}
      aria-label={label}
      title={label}
      className={classNames("builder-toolbar-palette-item", {
        "builder-toolbar-palette-item--dragging": isDragging,
      })}
      style={{ opacity: isDragging ? 0.45 : 1 }}
      onClick={handleActivate}
    >
      <BlockPaletteGlyph type={blockType} />
      <span className="builder-toolbar-palette-item-title">{label}</span>
    </button>
  );
}
